export default __webpack_public_path__ + "static/media/5h.33fa305b.png";